export const ORGANIZATION_LIMIT = 50;
export const USER_AVATAR_LIMIT = 5;

export const INCIDENT_LIMIT = 5;
